<ng-container *ngIf="['create-invoice','edit-invoice','view-invoice','recall-invoice'].indexOf(activeTab) == -1; else closeEditInvoice">
	<!-- <header class="data-table__create-section">
		<div class="search-field">
			<div class="search-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
					<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" transform="translate(1 1)">
						<circle cx="7" cy="7" r="7"/>
						<path stroke-linecap="square" d="M13.5 12.5L18 17"/>
					</g>
				</svg>
			</div>
			<input type="text" name="search" (keyup)="onSearch.emit($event.target.value)" i18n-placeholder="@@input.search_here" placeholder="Search invoices" #searchInput>
		</div>
		<div class="create-download">
			<a href="javascript:void(0);" id="create-new-invoice-trigger" [hidden]="activeTab == 'received-payments'" [class.clicked]="activeTab=='create-invoice'" (click)="changeTab.emit(activeTab == 'create-invoice' ? 'all-invoices' : 'create-invoice' )" data-text="X" class="tu-btn pink add-button">
				<svg width="14" height="14" viewBox="0 0 14 14">
					<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
						<path d="M1 7h12M7 1v12"/>
					</g>
				</svg>
				<span i18n="@@invoices.create_new_invoice">Create new invoice</span>
			</a>

			<a href="javascript:void(0);" id="record-payment-trigger" (click)="recordPayment.emit()" [hidden]="activeTab != 'received-payments'" data-text="X" class="tu-btn pink add-button">
				<svg width="14" height="14" viewBox="0 0 14 14">
					<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
						<path d="M1 7h12M7 1v12"/>
					</g>
				</svg>
				<span i18n="@@invoices.record_new_payment">Record new payment</span>
			</a>

			<a href="javascript:void(0);" id="quick-payment-trigger" (click)="quickPayment.emit()" *ngIf="userInfo?.halala_mobile ? true : false" data-text="X" class="tu-btn pink add-button">
				<svg width="14" height="14" viewBox="0 0 14 14">
					<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
						<path d="M1 7h12M7 1v12"/>
					</g>
				</svg>
				<span i18n="@@invoices.generate_quick_payment">Generate Quick Payment</span>
			</a>

			<a href="javascript:void(0);" class="downloadXl" [hidden]="activeTab=='drafts'" (click)="exportXls()" >
				<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
					<g fill="#0CC5D1" fill-rule="evenodd">
						<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
						<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
					</g>
				</svg>
				<span i18n="@@common.download_xls">download .xls</span>
			</a>
		</div>
	</header> -->

	<div class="filters_block">
		<svg class="search_icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
		<input type="text" class="filters_search" (keyup)="onSearch.emit($event.target.value)" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput />
		<div class="filters_btn_wrap">
			<!-- <button class="clear_allfilters saved_filters">
			  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				  <path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			  </svg>
			  Clear saved filters
		  </button> -->
			<button class="filters_block_btn filters_options" (click)="toggleFilter()">
				<svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M6 12H18M3 6H21M9 18H15" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				<ng-container i18n="@@filter.filters">Filters</ng-container> <span class="selected_filters2"></span>
			</button>
			<button class="filters_block_btn filter_export" (click)="exportXls()">
				<svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M21 3H3M18 13L12 7M12 7L6 13M12 7V21" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<span i18n="@@common.download_xls">download .xls</span>
			</button>
			<!-- <button class="filters_block_btn filter_export">
			  <svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
				  <path d="M21 3H3M18 13L12 7M12 7L6 13M12 7V21" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			  </svg>
			  Export...
		  </button> -->
		  	<a href="javascript:void(0);" id="create-new-invoice-list" class="tu-btn pink add-button" routerLink="/create-invoice" [queryParams]="{'create-invoice': true}">
				<svg width="14" height="14" viewBox="0 0 14 14">
					<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
						<path d="M1 7h12M7 1v12"/>
					</g>
				</svg>
			  <!-- <span i18n="@@invoices.create_new_invoice">Create new invoice</span> -->
			</a>
		</div>
	</div>
	<div class="filters_expanded">
		<h3 class="filters_expanded_header"> <ng-container i18n="@@filter.filters">Filters</ng-container></h3>
		<!-- <div class="checkbox_cont">
		  <div class="custom-checkbox filters_checkbox">
			  <input id="filters_checkbox" type="checkbox" class="select-item orders_inputAll">
			  <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
				  <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
			  </svg>
			  <svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				  <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
				  <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			  </svg>
		  </div>
		  <span>Remember for the next time</span>
	  </div> -->
		<div class="filters_expanded_bottom">
			<div class="date_wrap">
				<span class="date_title" i18n="@@ts.date">Date</span>
				<div class="field_cont">
					<label i18n="@@filter.from">from</label>
					<fieldset class="date sl">
						<div class="date-input-wrap">
							<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.from_date" placeholder="From Date" class="date-input" data-dd-init-set="false" data-dd-format="d/m/Y" data-dd-roundtrip="invoice-tab-date-range" />
						</div>
					</fieldset>
					<label i18n="@@filter.to">to</label>
					<fieldset class="date sl">
						<div class="date-input-wrap">
							<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.to_date" placeholder="To Date" class="date-input" data-dd-init-set="false" data-dd-format="d/m/Y" data-dd-roundtrip="invoice-tab-date-range" />
						</div>
					</fieldset>
				</div>
			</div>
			<div class="status_wrap">
				<span class="date_title" i18n="@@orders.status">Status</span>
				<div class="multiselect-container1" (click)="toggleSelectMenu();">
					<fieldset class="md">
						<select nice-select i18n-data-placeholder="@@option.select_status" data-placeholder="Select Status" class="nice-select" [(ngModel)]="invoice_status" (change)="filterByStatus()">
							<option value="" i18n="@@option.select_status">Select Status</option>
							<option value="paid" *ngIf="activeTab != 'received-payments'" i18n="@@ts.paid">Paid</option>
							<option value="unpaid" *ngIf="activeTab != 'received-payments'" i18n="@@ts.unpaid">Unpaid</option>
							<option value="partially" *ngIf="activeTab != 'received-payments'" i18n="@@ts.partially">Partially</option>
							<option value="canceled" *ngIf="activeTab != 'received-payments'" i18n="@@ts.canceled">Canceled</option>
							<option value="draft" *ngIf="activeTab != 'received-payments'" i18n="@@ts.draft">Draft</option>

							<option value="successful" *ngIf="activeTab == 'received-payments'" i18n="@@ts.successful">Successful</option>
							<option value="pending" *ngIf="activeTab == 'received-payments'" i18n="@@ts.pending">Pending</option>
							<option value="unsuccessful" *ngIf="activeTab == 'received-payments'" i18n="@@ts.unsuccessful">Un-Successful</option>
						</select>
					</fieldset>
				</div>
			</div>
			<div class="total_wrap">
				<span class="date_title" i18n="@@orders.total">Total</span>
				<div class="total_cont">
					<label i18n="@@filter.from">from</label>
					<input type="number" [(ngModel)]="minAmount" (keyup)="filterByAmount()" placeholder="1,00" appPreventScroll>
					<label i18n="@@filter.from">to</label>
					<input type="number" [(ngModel)]="maxAmount" (keyup)="filterByAmount()" placeholder="1,00" appPreventScroll>
				</div>
			</div>
			<button class="clear_allfilters" (click)="clearAllFilter()">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
					<path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				Clear all
			</button>
		</div>
	</div>

</ng-container>

<ng-template #closeEditInvoice>
	<!-- <div class="data-table__btn-wrap w-100">
		<div class="btn-row">
			<a (click)="changeTab.emit('all-invoices')" href="javascript:void(0)" id="closeNew" class="close-circle">
				<svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
					<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"></path>
				</svg>
			</a>
		</div>
	</div> -->
</ng-template>
